export default __webpack_public_path__ + "static/media/sounds/trcMicTestSuccess.mp3";